import { render, staticRenderFns } from "./VentilationModule.vue?vue&type=template&id=1a983541"
import script from "./VentilationModule.vue?vue&type=script&lang=js"
export * from "./VentilationModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports